import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Sport icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Sport } from '@sravni/design-system-icons'
 *
 * <Sport />
 * ```
 */
var Sport = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Sport", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m8.333 10.833.454 1.36c.226.681.864 1.14 1.581 1.14h5.465c.921 0 1.667-.745 1.667-1.666V6.796c0-.921-.746-1.667-1.667-1.667h-4.11", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.5 17.5 3.23 4.693A1.667 1.667 0 0 1 4.814 2.5h5.244c.92 0 1.666.746 1.666 1.667v5c0 .92-.746 1.666-1.666 1.666h-4.78", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Sport };
//# sourceMappingURL=Sport.js.map
